/**
 * Favorite template list helpers (GetTemplatesMulty isFavorite + SetFavoriteTemplate).
 */

/**
 * @param {Record<string, unknown> | null | undefined} template
 * @returns {boolean}
 */
export function isFavoriteTemplate(template) {
  const flag = template?.isFavorite ?? template?.IsFavorite;
  return flag === true || flag === "true" || flag === 1;
}

/**
 * Favorites first, then stable original order for the rest.
 * @param {unknown} templates
 * @returns {unknown[]}
 */
export function sortTemplatesWithFavoritesFirst(templates) {
  if (!Array.isArray(templates)) return [];
  const favorites = [];
  const rest = [];
  for (const tpl of templates) {
    if (isFavoriteTemplate(tpl)) favorites.push(tpl);
    else rest.push(tpl);
  }
  return favorites.concat(rest);
}

/**
 * @param {unknown} templates
 * @param {string} templateId
 * @param {boolean} isFavorite
 * @returns {unknown[]}
 */
export function patchTemplateFavorite(templates, templateId, isFavorite) {
  if (!Array.isArray(templates)) return [];
  const id = String(templateId ?? "");
  return templates.map((tpl) => {
    if (!tpl || String(tpl.templateId) !== id) return tpl;
    return {
      ...tpl,
      isFavorite: !!isFavorite,
      IsFavorite: !!isFavorite,
    };
  });
}
